<footer class="portfolio-footer">
  <!-- portfolio-footer logo -->
  <div class="portfolio-footer__logo container">
    <h1 class="portfolio-footer__title">
      {{ footerData()?.title | translateData }}
    </h1>
  </div>
  <!-- portfolio-footer menu -->
  <div class="portfolio-footer__menu container">
    <!-- pages menu -->
    <!-- <ul class="menu-pages">
      @for (page of pagesFirstSection; track page.id) {
        <li class="menu-pages__item">
          <a [routerLink]="page.link">
            {{ page.name | translate }}
          </a>
        </li>
      }
    </ul> -->
    <!-- socials menu -->
    <ul class="social-media">
      @for (link of footerData()?.links; track link?.url) {
        @if (socialMediaConstant?.[link.type]) {
          <li class="social-media__item-container">
            <a
              class="social-media__item"
              [href]="socialMediaConstant[link.type].prefixUrl + link.url"
              target="_blank">
              <img
                class="social-media-img"
                [ngSrc]="socialMediaConstant[link.type].icon"
                width="20"
                height="20"
                [alt]="link.url" />
            </a>
          </li>
        }
      }
    </ul>
    <!-- categories menu -->
    <!-- <ul class="categories">
      @for (page of pagesSecondSection; track page.id) {
        <li class="categories__item">
          <a [routerLink]="page.link">
            {{ page.name | translate }}
          </a>
        </li>
      }
    </ul> -->
  </div>
  <!-- portfolio-footer content -->
  <div class="portfolio-footer__content container">
    <!-- business info -->
    <ul class="business-info"></ul>
    <!-- description -->
    <p class="business-description">
      {{ (footerData()?.description | translateData)?.slice(0, 350) }}
      @if (((footerData()?.description | translateData)?.length || 0) > 350) {
        <span>...</span>
      }
    </p>
    <!-- business location -->
    <ul class="business-location">
      @for (location of companyLocation; track location?.id) {
        <li class="business-location__item">
          <!-- location label & icon -->
          <p class="location-label">
            <span class="location-label__icon">
              <i class="iconsax info-icon" [attr.icon-name]="location.icon"></i>
            </span>
            <span class="location-label__name">
              {{ location.name | translate }}
            </span>
          </p>

          <!-- location value -->
          <p class="location-value">
            {{ location.value | translateData }}
          </p>
        </li>
      }
    </ul>
  </div>
</footer>

<!-- bottom page content -->
<div class="portfolio-footer-company">
  <a routerLink="">{{ 'home.powered_by_we_joiner' | translate }}</a>
</div>
